import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowUpRight } from "lucide-react";
import { CERTIFICATION_STATEMENT } from "../../config/downloads";

/**
 * Honest compliance statement — never "Coming Soon".
 */
export default function CertificationStatement({ showCta = true }) {
  return (
    <div
      className="border border-border bg-secondary/40 p-6 lg:p-8"
      data-testid="certification-statement"
    >
      <div className="flex items-start gap-4">
        <ShieldCheck
          size={22}
          strokeWidth={1.3}
          className="text-[color:var(--gold)] shrink-0 mt-0.5"
        />
        <div>
          <div className="font-mono-2 text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-2">
            § {CERTIFICATION_STATEMENT.title}
          </div>
          {CERTIFICATION_STATEMENT.body.map((paragraph) => (
            <p
              key={paragraph}
              className="text-sm text-steel-text leading-relaxed mt-3 first:mt-0"
            >
              {paragraph}
            </p>
          ))}
          {showCta && (
            <Link
              to="/#contact"
              className="mt-5 inline-flex items-center gap-2 font-mono-2 text-[11px] tracking-[0.2em] uppercase"
              style={{ color: "var(--gold)" }}
              data-testid="certification-contact-cta"
            >
              {CERTIFICATION_STATEMENT.contactCta}
              <ArrowUpRight size={14} />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
